import React, { useContext, useState } from "react";
import { NotifyContext } from "../../context/notifyContext";
import { Subscriber } from "../../Types/newsletter";
import NewsletterAPI from "../../services/api/newsletterService";
import Button from "../../UI/Button/Button";
import ButtonLoading from "../../UI/Button/ButtonLoading";
import Input from "../../UI/Input/Input";
import Select from "../../UI/Select/Select";

interface AddOrUpdateSubscriberProps {
  onClose: () => void;
  initialState?: Subscriber | null;
}

export default function AddOrUpdateSubscriber({
  onClose,
  initialState,
}: AddOrUpdateSubscriberProps) {
  const notify = useContext(NotifyContext);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: initialState?.email || "",
    status: initialState?.status || "active",
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (initialState?.id) {
        await NewsletterAPI.update_subscriber(initialState.id, formData);
        notify("Abonné mis à jour avec succès", "success");
      } else {
        await NewsletterAPI.update_subscriber(0, formData);
        notify("Abonné créé avec succès", "success");
      }
      onClose();
    } catch (error) {
      notify(error, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <Input
        label="Email"
        type="email"
        value={formData.email}
        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        required
      />
      <Select
        label="Statut"
        value={formData.status}
        onChange={(e) => setFormData({ ...formData, status: e.target.value as "active" | "unsubscribed" })}
        required
      >
        <option value="active">Actif</option>
        <option value="unsubscribed">Désabonné</option>
      </Select>
      <div className="flex justify-end gap-2">
        <Button color="error" onClick={onClose}>
          Annuler
        </Button>
        <ButtonLoading
          type="submit"
          loading={loading}
          label={initialState?.id ? "Mettre à jour" : "Créer"}
        />
      </div>
    </form>
  );
} 